import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'

import { ROUTE_NAMES } from '~/constants/routes'
import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

// eslint-disable-next-line consistent-return
export default defineNuxtRouteMiddleware(async (to) => {
  const { isUserAuthenticatedSeller } = useUserStore()

  const businessFeaturesStore = useBusinessFeaturesStore()

  if (
    isUserAuthenticatedSeller.value &&
    !businessFeaturesStore.hasFetchBusinessFeature
  ) {
    await businessFeaturesStore.fetchBusinessFeatures()
  }

  // Redirect user according to retrieved website business
  // features and current page requirements.
  const requiredFeatures = to.meta?.businessFeatures || []

  const hasRightsToAccessPage = requiredFeatures.every(
    businessFeaturesStore.isFeatureEnabled,
  )

  if (!hasRightsToAccessPage) {
    return navigateTo({
      name: ROUTE_NAMES.NO_ACCESS,
    })
  }
})
